var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextBtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.106 22.106L37 28l-5.894 5.895M17.632 28h19",
    stroke: "#FFF4E8",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    transform: "rotate(-180 28 28)",
    stroke: "#FFF4E8"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMzEuMTA2IDIyLjEwNkwzNyAyOGwtNS44OTQgNS44OTVNMTcuNjMyIDI4aDE5IiBzdHJva2U9IiNGRkY0RTgiIHN0cm9rZS13aWR0aD0iMiIvPjxjaXJjbGUgY3g9IjI4IiBjeT0iMjgiIHI9IjI3LjUiIHRyYW5zZm9ybT0icm90YXRlKC0xODAgMjggMjgpIiBzdHJva2U9IiNGRkY0RTgiLz48L3N2Zz4=";
export { SvgNextBtn as ReactComponent };